import React, { useState, useRef } from 'react';
import ListPage, { ui } from '../../components/ListPage';

const toFarsi = n => n === null || n === undefined ? '' : String(n).replace(/[0-9]/g, d => '۰۱۲۳۴۵۶۷۸۹'[d]);
const toEng   = s => String(s).replace(/[۰-۹]/g, d => '۰۱۲۳۴۵۶۷۸۹'.indexOf(d).toString());
const numFmt  = n => n ? Number(n).toLocaleString('fa-IR') : '•';

const API = (path, opts = {}) =>
  fetch(`/api/accounting${path}`, {
    headers: { 'Content-Type': 'application/json', Authorization: `Bearer ${localStorage.getItem('access')}` },
    ...opts,
  }).then(r => r.json());

const FInput = ({ label, value, onChange, placeholder, width, numeric }) => (
  <div style={{ display:'flex', flexDirection:'column', gap:'3px' }}>
    <label style={{ fontSize:'11px', fontWeight:'600', color:'#555' }}>{label}</label>
    <input value={numeric ? toFarsi(value) : value}
      onChange={e => onChange(numeric ? toEng(e.target.value).replace(/\D/g,'') : e.target.value)}
      placeholder={placeholder || ''}
      style={{ padding:'7px 10px', border:'1.5px solid #e0e0e0', borderRadius:'7px', fontSize:'13px',
        fontFamily:"'Vazirmatn',Tahoma,sans-serif", outline:'none', direction:'rtl', textAlign:'right',
        width: width || '100px', boxSizing:'border-box', background:'#fff' }} />
  </div>
);

const FCheck = ({ label, checked, onChange }) => (
  <label style={{ display:'flex', alignItems:'center', gap:'6px', cursor:'pointer', fontSize:'13px', fontWeight:'600',
    color: checked ? '#1a237e' : '#999', userSelect:'none', padding:'4px 8px', borderRadius:'6px',
    background: checked ? '#e8eaf6' : '#f5f5f5', border: `1.5px solid ${checked ? '#7986cb' : '#e0e0e0'}`, transition:'all 0.15s' }}>
    <input type="checkbox" checked={checked} onChange={e => onChange(e.target.checked)} style={{ width:'15px', height:'15px', cursor:'pointer' }} />
    {label}
  </label>
);

export default function AccountingPreviousYears({ user, onBack }) {
  const [year,    setYear]    = useState('');
  const [kol,     setKol]     = useState('');
  const [moein,   setMoein]   = useState('');
  const [taf,     setTaf]     = useState('');
  const [remark,  setRemark]  = useState('');
  const [remark2, setRemark2] = useState('');
  const [chkDebit,  setChkDebit]  = useState(false);
  const [chkCredit, setChkCredit] = useState(true);
  const [searchOnly, setSearchOnly] = useState(false);
  const [applied, setApplied] = useState({ debit: false, credit: true });

  const [data,    setData]    = useState([]);
  const [loading, setLoading] = useState(false);
  const [error,   setError]   = useState('');
  const [search,  setSearch]  = useState('');
  const [total,   setTotal]   = useState(0);
  const [page,    setPage]    = useState(1);
  const [hasMore, setHasMore] = useState(false);
  const [loadingMore, setLoadingMore] = useState(false);
  const searchRef = useRef(null);

  const buildParams = (pg = 1) => {
    const y2 = toEng(year).slice(-2);
    const params = new URLSearchParams();
    if (year)    params.set('year',   y2);
    if (kol)     params.set('kol',    kol);
    if (moein)   params.set('moein',  moein);
    if (taf)     params.set('taf',    taf);
    if (remark)  params.set('remark', remark);
    if (remark2) params.set('remark2',remark2);
    params.set('debit',  chkDebit  ? '1' : '0');
    params.set('credit', chkCredit ? '1' : '0');
    params.set('page', pg);
    return params;
  };

  const load = async () => {
    if (!year && !kol && !moein && !taf && !remark && !remark2) { setError('حداقل یک فیلتر وارد کنید'); return; }
    setLoading(true); setError(''); setSearch(''); setPage(1);
    setApplied({ debit: chkDebit, credit: chkCredit });
    const j = await API(`/previous-years/?${buildParams(1)}`);
    setLoading(false);
    if (j.ok) { setData(j.data); setTotal(j.total); setHasMore(j.has_more); setPage(1); }
    else setError(j.msg || 'خطا در دریافت اطلاعات');
  };

  const loadMore = async () => {
    const nextPage = page + 1; setLoadingMore(true);
    const j = await API(`/previous-years/?${buildParams(nextPage)}`);
    setLoadingMore(false);
    if (j.ok) { setData(prev => [...prev, ...j.data]); setHasMore(j.has_more); setPage(nextPage); }
  };

  const filteredData = (() => {
    if (!search.trim()) return data;
    const str = search.trim();
    const sEng = toEng(str);
    const isNum = /^\d+$/.test(sEng);
    return data.filter(r => {
      if (isNum) {
        if (searchOnly) return String(r.document_no) === sEng;
        return (String(r.document_no)===sEng || String(r.kol)===sEng || String(r.moein)===sEng ||
          String(r.taf)===sEng || String(r.debit)===sEng || String(r.credit)===sEng ||
          r.document_date===str || r.account_title.includes(str) || r.contractor.includes(str) || r.document_remark.includes(str));
      }
      return (r.account_title.includes(str) || r.contractor.includes(str) || r.document_remark.includes(str) || r.document_date.includes(str));
    });
  })();

  const showDebit  = applied.debit;
  const showCredit = applied.credit;

  const toolbar = (
    <div style={{ display:'flex', flexDirection:'column', gap:'10px', width:'100%' }}>
      <div style={{ display:'flex', alignItems:'flex-end', gap:'10px', flexWrap:'wrap' }}>
        <FInput label="سال مالی (۲ رقم)" value={year} onChange={v => setYear(v.slice(0,2))} placeholder="۹۰" width="75px" numeric />
        <FInput label="حساب کل" value={kol} onChange={setKol} width="80px" numeric />
        <FInput label="حساب معین" value={moein} onChange={setMoein} width="90px" numeric />
        <FInput label="حساب تفصیلی" value={taf} onChange={setTaf} width="90px" numeric />
        <FInput label="شرح" value={remark} onChange={setRemark} placeholder="جستجو در شرح..." width="180px" />
        <FInput label="شرح (۲)" value={remark2} onChange={setRemark2} placeholder="جستجو در شرح..." width="180px" />
      </div>
      <div style={{ display:'flex', alignItems:'flex-end', gap:'10px', flexWrap:'wrap' }}>
        <FCheck label="بدهکار"   checked={chkDebit}  onChange={setChkDebit} />
        <FCheck label="بستانکار" checked={chkCredit} onChange={setChkCredit} />
        <div style={{ width:'1px', background:'#e0e0e0', height:'32px', margin:'0 4px' }} />
        <div style={{ display:'flex', flexDirection:'column', gap:'3px', flex:1, minWidth:'160px' }}>
          <label style={{ fontSize:'11px', fontWeight:'600', color:'#555' }}>جستجو</label>
          <input ref={searchRef} value={search} onChange={e => setSearch(e.target.value)} placeholder="جستجو در نتایج..."
            style={{ padding:'7px 10px', border:'1.5px solid #e0e0e0', borderRadius:'7px', fontSize:'13px',
              fontFamily:"'Vazirmatn',Tahoma,sans-serif", outline:'none', direction:'rtl', flex:1 }} />
        </div>
        <FCheck label="فقط در شماره سند" checked={searchOnly} onChange={setSearchOnly} />
        <div style={{ display:'flex', flexDirection:'column', gap:'3px' }}>
          <label style={{ fontSize:'11px', fontWeight:'600', color:'#555' }}>تعداد</label>
          <input value={total > 0 ? `${toFarsi(data.length)} از ${toFarsi(total)}` : toFarsi(filteredData.length)} readOnly
            style={{ padding:'7px 10px', border:'1.5px solid #e0e0e0', borderRadius:'7px', fontSize:'12px',
              fontFamily:"'Vazirmatn',Tahoma,sans-serif", textAlign:'center', width:'100px', background:'#f5f5f5', color:'#1a2f50', fontWeight:'700' }} />
        </div>
        <button onClick={load} disabled={loading} style={{ padding:'9px 28px', background:'linear-gradient(135deg,#1a2f50,#1a237e)',
          color:'#fff', border:'none', borderRadius:'8px', cursor:'pointer', fontFamily:'inherit', fontSize:'13px', fontWeight:'700', whiteSpace:'nowrap', alignSelf:'flex-end' }}>
          {loading ? '⏳ در حال بارگذاری...' : '▶ نمایش'}
        </button>
      </div>
    </div>
  );

  const footer = (hasMore && !search) ? (
    <button onClick={loadMore} disabled={loadingMore} style={{ padding:'10px 40px',
      background: loadingMore ? '#ccc' : 'linear-gradient(135deg,#1a2f50,#1a237e)', color:'#fff', border:'none',
      borderRadius:'8px', cursor: loadingMore?'default':'pointer', fontFamily:'inherit', fontSize:'13px', fontWeight:'700' }}>
      {loadingMore ? '⏳ در حال بارگذاری...' : `▼ بارگذاری ۲۰۰ رکورد بعدی (${toFarsi(total - data.length)} باقی‌مانده)`}
    </button>
  ) : null;

  return (
    <ListPage user={user} onBack={onBack} title="اسناد نرم‌افزار قبل" subtitle="تنظیم حساب — سامانه ارجان"
      toolbar={toolbar} error={error} footer={footer}>
      <table style={ui.table}>
        <thead style={{ position:'sticky', top:0, zIndex:10 }}>
          <tr>
            <th style={{ ...ui.th, width:'60px' }}>سال مالی</th>
            <th style={{ ...ui.th, width:'55px' }}>سند</th>
            <th style={{ ...ui.th, width:'85px' }}>تاریخ</th>
            <th style={{ ...ui.th, width:'50px' }}>کل</th>
            <th style={{ ...ui.th, width:'55px' }}>معین</th>
            <th style={{ ...ui.th, width:'65px' }}>تفصیلی</th>
            <th style={{ ...ui.th, textAlign:'right', minWidth:'160px' }}>شرح حساب</th>
            <th style={{ ...ui.th, textAlign:'right', minWidth:'150px' }}>پیمانکار</th>
            <th style={{ ...ui.th, textAlign:'right', minWidth:'200px' }}>شرح سند</th>
            {showDebit  && <th style={{ ...ui.th, width:'110px', background:'#1a3a5c', color:'#ef9a9a' }}>بدهکار</th>}
            {showCredit && <th style={{ ...ui.th, width:'110px', background:'#1a3a5c', color:'#a5d6a7' }}>بستانکار</th>}
          </tr>
        </thead>
        <tbody>
          {filteredData.map((r, i) => {
            const bg = i % 2 === 0 ? '#fff' : '#fdf6e3';
            return (
              <tr key={i} style={{ background:bg }}
                onMouseEnter={e => e.currentTarget.style.background='#e8f0fe'}
                onMouseLeave={e => e.currentTarget.style.background=bg}>
                <td style={{ ...ui.td, color:'#1a237e', fontWeight:'700' }}>{toFarsi(r.financial_year)}</td>
                <td style={{ ...ui.td, fontWeight:'700', color:'#1a2f50' }}>{toFarsi(r.document_no)}</td>
                <td style={{ ...ui.td, fontFamily:'monospace', fontSize:'11px' }}>{r.document_date}</td>
                <td style={ui.td}>{toFarsi(r.kol)   || '—'}</td>
                <td style={ui.td}>{toFarsi(r.moein)  || '—'}</td>
                <td style={ui.td}>{toFarsi(r.taf)    || '—'}</td>
                <td style={{ ...ui.td, textAlign:'right', fontSize:'12px' }}>{r.account_title}</td>
                <td style={{ ...ui.td, textAlign:'right', fontSize:'11px', color:'#555' }}>{r.contractor || '—'}</td>
                <td style={{ ...ui.td, textAlign:'right', fontSize:'11px', color:'#555', maxWidth:'240px', overflow:'hidden', textOverflow:'ellipsis' }} title={r.document_remark}>{r.document_remark}</td>
                {showDebit  && <td style={{ ...ui.td, textAlign:'left', fontFamily:'monospace', fontWeight:'700', color: r.debit>0 ? '#b71c1c' : '#ccc', paddingLeft:'12px' }}>{r.debit > 0 ? numFmt(r.debit) : '•'}</td>}
                {showCredit && <td style={{ ...ui.td, textAlign:'left', fontFamily:'monospace', fontWeight:'700', color: r.credit>0 ? '#1b5e20' : '#ccc', paddingLeft:'12px' }}>{r.credit > 0 ? numFmt(r.credit) : '•'}</td>}
              </tr>
            );
          })}
        </tbody>
      </table>
      {!loading && data.length === 0 && <div style={ui.empty}>{error ? '' : '🔍 فیلترها را وارد کنید و دکمه نمایش را بزنید'}</div>}
    </ListPage>
  );
}
